import { render, staticRenderFns } from "./free-plan.vue?vue&type=template&id=005d5c86&scoped=true&"
import script from "./free-plan.vue?vue&type=script&lang=js&"
export * from "./free-plan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d5c86",
  null
  
)

export default component.exports